import {
    DefaultButton,
    Dialog, DialogFooter, DialogType, PrimaryButton,
} from '@fluentui/react'
import React, { useEffect, useState } from 'react'
import { Columns } from 'react-bulma-components'
import FilteredVirtualCombobox from 'components/inputs/filteredVirtualCombobox'
import useTranslate from 'helpers/hooks/useTranslate'
import styles from 'styles/components/pages/orders/[id]/client/delivery-step/label-modal.module.scss'

/**
 * TransportLabelModal
 * @param {object} props Props
 * @param {boolean} props.isVisible isVisible
 * @param {(isVisible: boolean) => void} props.setIsVisible setIsVisible
 * @param {string} props.lang lang
 * @param {boolean=} props.isDownloading isDownloading
 * @param {(nbPerPage: number) => void} props.onPrint onPrint
 * @param {number=} props.defaultLabelFormat Default number of labels per page, when the selection is a single client
 * @returns {JSX.Element | null} transport label modal
 */
export default function TransportLabelModal({
    isVisible,
    setIsVisible,
    lang,
    isDownloading = false,
    onPrint,
    defaultLabelFormat = null,
}) {
    const { tKey } = useTranslate({ lang })
    const [selectedId, setSelectedId] = useState(defaultLabelFormat)

    // Reset to the client's default (or empty, for a multi-client selection) each time the modal opens.
    useEffect(() => {
        if (isVisible)
            setSelectedId(defaultLabelFormat)
    }, [isVisible, defaultLabelFormat])

    if (!isVisible)
        return null

    return (
        <Dialog
            hidden={!isVisible}
            dialogContentProps={{
                type: DialogType.largeHeader,
                title: tKey('printLabels'),
                subText: tKey('printLabelsSubtitle'),
                styles: {
                    innerContent: { height: '100%' },
                },
            }}
            maxWidth="555px"
            minWidth="400px"
        >
            <form
                onSubmit={ev => {
                    ev.preventDefault()
                    if (selectedId)
                        onPrint(selectedId)
                }}
            />
            <div className={styles['label-modal']}>
                <Columns>
                    <Columns.Column size="half">
                        <FilteredVirtualCombobox
                            label={tKey('nbOfLabel')}
                            options={[
                                { key: 1, text: '1' },
                                { key: 2, text: '2' },
                                { key: 4, text: '4' },
                                { key: 6, text: '6' },
                                { key: 8, text: '8' },
                                { key: 10, text: '10' },
                                { key: 12, text: '12' },
                            ]}
                            selectedKey={selectedId}
                            onChange={(ev, option) => {
                                ev.preventDefault()
                                setSelectedId(option.key)
                            }}
                            required
                        />
                    </Columns.Column>
                </Columns>
                <DialogFooter className={styles.footer}>
                    <DefaultButton
                        onClick={() => setIsVisible(false)}
                        text={tKey('cancel')}
                        disabled={isDownloading}
                    />
                    <PrimaryButton
                        onClick={e => {
                            e.preventDefault()
                            onPrint(selectedId)
                        }}
                        text={tKey('print')}
                        disabled={isDownloading || !selectedId}
                    />
                </DialogFooter>
            </div>
        </Dialog>
    )
}
